var map = {
	"./gray_circle.png": 1430,
	"./gray_large.png": 1431,
	"./gray_medium.png": 1432,
	"./gray_small.png": 1433,
	"./gray_square.png": 673,
	"./green_large.png": 1434,
	"./green_medium.png": 1435,
	"./green_small.png": 1436,
	"./orange_large.png": 1437,
	"./orange_medium.png": 1438,
	"./orange_small.png": 1439,
	"./yellow_circle.png": 794,
	"./yellow_large.png": 1440,
	"./yellow_medium.png": 1441,
	"./yellow_small.png": 1442,
	"./yellow_trapezium.png": 1443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1429;